<!--
  Props:

  Optional:
  1) menuSize - Specify a size for the menu width that will be multiplied by 50
                example: size 5 = 250px; default is 3 (150px)
  2) direction - Either left (default) or right, this will change where the
                 content will be appended to the menu-trigger

 -->

<template>
  <div>
    <div @click.stop="createMenu(getMenuContent)" class="dropdown-button">
      <slot name="menu_trigger" />
    </div>
    <div style="display: none">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        positionTop: 0,
        positionLeft: 0,
        positionRight: 0,
        elementHeight: 0,
        menuContentHeight: 0,
      };
    },
    props: {
      menuSize: {
        type: Number,
        default() {
          return 3;
        },
      },
      direction: {
        type: String,
        default() {
          return 'left';
        },
      },
      noMargin: {
        type: Boolean,
        default() {
          return false;
        },
      },
      isSubmenu: { 
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    computed: {
      widthCalc() {
        return `${this.menuSize * 50}px`;
      },
      xPositionCalc() {
        if (this.direction === 'left') {
          return `${this.positionLeft}px`;
        } else if (this.direction === 'right') {
          return `${this.positionRight - this.menuSize * 50}px`;
        }
      },
      getMenuContent() {
        return this.$el.querySelector('[menu-content]');
      },
    },
    methods: {
      repositionElement() {
        this.getElementPosition();
        const renderedMenu = document.getElementById('pl-menu');
        renderedMenu.style.left = this.xPositionCalc;
        renderedMenu.style.top = this.yPositionCalc();
        const newMaxHeight = this.getMaxHeight();
        renderedMenu.style['max-height'] = newMaxHeight;
      },
      getElementPosition() {
        const { top, left, right, height } = this.$el.getBoundingClientRect();
        this.positionTop = top;
        this.positionLeft = left;
        this.positionRight = right;
        this.elementHeight = height;
      },
      getMaxHeight() {
        const totalHeight = document.body.offsetHeight;
        if (totalHeight - this.positionTop > 190) {
          return `${totalHeight - this.positionTop - 70}px`;
        } else {
          return `${totalHeight}px`;
        }
      },
      yPositionCalc() {
        const screenSize = window.innerHeight;
        // If the element is too close to the bottom of the page,
        // append the menu to the top of the menu-trigger, if not, append
        // to the bottom of it.
        if (screenSize - this.positionTop > 190) {
          return `${(this.positionTop + 8) + this.elementHeight}px`;
        } else {
          return `${(this.positionTop + 8) - this.menuContentHeight}px`;
        }
      },
      createDeleteEvent() {
        const overlay = document.getElementById('overlay');

        if (overlay && overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }

        const plMenu = document.getElementById('pl-menu');

        if (plMenu && plMenu.parentNode) {
          plMenu.parentNode.removeChild(plMenu);
        }

        window.removeEventListener('resize', this.repositionElement);
      },
      createOverlay() {
        const overlay = document.createElement('div');
        overlay.setAttribute('id', 'overlay');
        overlay.style.cssText = `position: fixed;
          z-index: 150; left: 0; top: 0;
          width: 100%; height: 100%; background-color: transparent;`;
        overlay.onclick = () => this.createDeleteEvent();
        document.body.appendChild(overlay);
        // return overlay to use in createMenu
        return overlay;
      },
      createMenu(content) {
        this.getElementPosition();
        let overlay;
        if (!this.isSubmenu) {
          overlay = this.createOverlay();
        } else {
          overlay = document.getElementById('overlay');
          if (!overlay) {
            overlay = this.createOverlay();
          }
        }

        const maxHeight = this.getMaxHeight();
        const newMenu = document.createElement('div');
        newMenu.appendChild(content);
        newMenu.setAttribute('id', 'pl-menu');
        newMenu.onclick = () => this.createDeleteEvent();
        newMenu.style.cssText = `visibility: hidden; z-index: 100`;
        overlay.appendChild(newMenu);
        this.menuContentHeight = newMenu.getBoundingClientRect().height;
        if (this.noMargin) {
          newMenu.childNodes[0].style.cssText = 'margin:0px';
        }
        newMenu.style.cssText = `position: absolute; width: ${this.widthCalc};
          max-height: ${maxHeight}; top: ${this.yPositionCalc()} ; z-index: 999;
          overflow-y: auto; background-color: #FEFEFE; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; border-radius: 7px`;

        if (this.isSubmenu) {
          newMenu.style.cssText += `left: ${this.positionRight}px;`;
        } else {
          if (this.direction === 'absolute-right') {
            newMenu.style.cssText += 'right:0';
          } else {
            newMenu.style.cssText += `left: ${this.xPositionCalc};`;
          }
        }
        window.addEventListener('resize', this.repositionElement);
      },
      /* createMenu(content) {
        this.getElementPosition();
        const overlay = this.createOverlay();

        const maxHeight = this.getMaxHeight();
        const newMenu = document.createElement('div');
        newMenu.appendChild(content);
        newMenu.setAttribute('id', 'pl-menu');
        newMenu.onclick = () => this.createDeleteEvent();
        // Append the element with visibility hidden just to get the height of it
        newMenu.style.cssText = `visibility: hidden; z-index: 100`;
        // append child to overlay not document body to avoid positioning bug- this is why we return overlay in createOverlay
        overlay.appendChild(newMenu);
        // Get the height of the element to be the offset in case of appending it to the
        // top of the menu-trigger if needed
        this.menuContentHeight = newMenu.getBoundingClientRect().height;
        if (this.noMargin) {
          newMenu.childNodes[0].style.cssText = 'margin:0px';
        }
        newMenu.style.cssText = `position: absolute; width: ${this.widthCalc};
          max-height: ${maxHeight}; top: ${this.yPositionCalc()} ; z-index: 999;
          overflow-y: auto; background-color: #FEFEFE; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; border-radius: 7px`;
        if (this.direction === 'absolute-right') {
          newMenu.style.cssText += 'right:0';
        } else {
          newMenu.style.cssText += `left: ${this.xPositionCalc};`;
        }
        window.addEventListener('resize', this.repositionElement);
      }, */
    },
    mounted() {},
  };
</script>



// WEBPACK FOOTER //
// plMenu.vue?0d68040e